"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeelPayNative = void 0;
class FeelPayNative {
    startAdvertising() {
        throw new Error('Method not implemented.');
    }
    startDiscovery() {
        throw new Error('Method not implemented.');
    }
    sendMessage() {
        throw new Error('Method not implemented.');
    }
    stopAllConnections() {
        throw new Error('Method not implemented.');
    }
    async createChatRoom(config) {
        var _a;
        try {
            // Use the exposed API
            // @ts-expect-error
            if ((_a = window.electronAPI) === null || _a === void 0 ? void 0 : _a.createChatRoom) {
                // @ts-expect-error
                return await window.electronAPI.createChatRoom(config);
            }
            else {
                throw new Error('Electron API is not available');
            }
        }
        catch (error) {
            console.error('Error during printing:', error);
            throw new Error('Failed to print.');
        }
    }
    async getAllPrinters() {
        var _a;
        try {
            // Use the exposed API
            // @ts-expect-error
            if ((_a = window.electronAPI) === null || _a === void 0 ? void 0 : _a.getPrinters) {
                // @ts-expect-error
                return await window.electronAPI.getPrinters();
            }
            else {
                throw new Error('Electron API is not available');
            }
        }
        catch (error) {
            console.error('Error during printing:', error);
            throw new Error('Failed to print.');
        }
    }
    // Print a receipt
    // Print a receipt
    async print({ options, profile, data, address, printerName }) {
        var _a;
        try {
            // Use the exposed API
            // @ts-expect-error
            if ((_a = window.electronAPI) === null || _a === void 0 ? void 0 : _a.printReceipt) {
                // @ts-expect-error
                window.electronAPI.printReceipt(options, profile, data, address, printerName);
            }
            else {
                throw new Error('Electron API is not available');
            }
        }
        catch (error) {
            console.error('Error during printing:', error);
            throw new Error('Failed to print.');
        }
    }
    async initializeScanner() {
        try {
            //@ts-expect-error
            const devices = await window.hidAPI.getDevices();
            console.log('Connected devices:', devices);
            if (devices.length > 0) {
                await this.connectToScanner(devices[0]);
            }
            else {
                await this.requestNewDevice(0x1234);
            }
            return (devices || []);
        }
        catch (error) {
            console.error('Error initializing scanner:', error);
            throw error;
        }
    }
    async requestNewDevice(vendorId) {
        try {
            const filters = [{ vendorId }];
            //@ts-expect-error
            const device = await window.hidAPI.requestDevice(filters);
            await this.connectToScanner(device);
        }
        catch (error) {
            console.error('Error requesting device:', error);
        }
    }
    async connectToScanner(device) {
        try {
            //@ts-ignore
            const connectedDevice = await window.hidAPI.connectToDevice(device);
            console.log('Connected to device:', connectedDevice.productName);
            connectedDevice.addEventListener('inputreport', (event) => {
                const barcode = new TextDecoder().decode(event.data.buffer);
                console.log('Scanned Barcode:', barcode);
                // addToCart(barcode);
            });
        }
        catch (error) {
            console.error('Error connecting to device:', error);
        }
    }
    async proompt({ apiKey, shopInfo }) {
        var _a, _b;
        try {
            //@ts-expect-error
            if ((_a = window.electronAPI) === null || _a === void 0 ? void 0 : _a.proompt) {
                //@ts-expect-error
                return await ((_b = window.electronAPI) === null || _b === void 0 ? void 0 : _b.proompt({ apiKey, shopInfo }));
            }
            else {
                throw new Error("Platform not supported");
            }
        }
        catch (error) {
            throw new Error(error.message);
        }
    }
}
exports.FeelPayNative = FeelPayNative;
//# sourceMappingURL=index.js.map